import { filterListToOptions } from '@/ui/helpers/index';
import { Assignee } from '@/entities/assignee';

export const filterListToOptionsUsers = (users: BaseFilterEntity[]) =>
  filterListToOptions<string>({ data: users }).map(e => ({ ...e, value: `user_${e.value}` }));

export const filterAssigneesListToOptionsUsers = (assignees: Array<Assignee>) =>
  assignees.map(item => ({
    value: `user_${item.id}`,
    label: item.data.name,
  }));

export const mapUsersIdsToOptions = (users: Array<string>) => users.map((user: string) => user.startsWith('user_') ? user : `user_${user}`);
export const mapGroupIdsToOptions = (groups: Array<string>) => groups.map((group: string) => group.startsWith('group_') ? group : `group_${group}`);

export const filterListToOptionsGroups = (groups: BaseFilterEntity[]) =>
  filterListToOptions<string>({ data: groups }).map(e => ({ ...e, value: `group_${e.value}` }));

export const filterListToEditableUsers = (users: Array<string | number>) =>
  users.map(v => v.toString().replace('user_', ''));

export const filterListToEditableGroups = (users: Array<string | number>) =>
  users.map(v => v.toString().replace('group_', ''));

interface SeparatedUsersAndGroups {
  users: string[];
  groups: string[];
}

export const mapAssigneesListToOptions = (users: BaseFilterEntity[], groups: BaseFilterEntity[]) => {
  return [
    ...filterListToOptionsUsers(users),
    ...filterListToOptionsGroups(groups),
  ];
};

export const separateUsersAndGroups = (value: string[]): SeparatedUsersAndGroups => {
  const users: Array<string> = [];
  const groups: Array<string> = [];

  value.forEach(v => {
    if ((v as string).includes('user_')) {
      users.push(v as string);
    } else if ((v as string).includes('group_')) {
      groups.push(v as string);
    }
  });

  return { users, groups };
};
